import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { CButton } from '@coreui/react-pro';
import classNames from 'classnames';

import { removeSpecialCharacters, tryParseJSON, useOutsideHandling } from '../../utils';
import {
     CAMS_CARE_URL,
     GUEST_PATH,
     LOCAL_LICENSEE,
     LOCAL_ORG_USER,
     MODAL_LOGIN,
     MY_LEARNING_PATH,
     MY_ORG_PATH,
     POPUP_REGISTER,
     SUBSCRIBER_PATH,
     SYSTEM_ADMIN_ROUTES,
     USER_ROLES,
} from '../../constants';
import { isAuth } from '../../helpers/auth';
import useWindowSize from '../../helpers/hooks/useWindowSize';
import { checkAcceptSeatLayout } from '../../helpers/subscriber';

import images from '../../assets/images';

import LicenseePopup from '../../components/General/Popups/LicenseePopup';
import LoginModal from '../../components/Auth/LoginModal';
import RegisterModal from '../../components/Auth/RegisterModal';
import { CartInfoWithPrice } from '../../components/CMS/Guest/Cart/CartInfo';

import { setShow, setSidebarShow, toggleTheme } from '../../actions/general';

const GuestHeader = () => {
     const wrapperRef = useRef(null);
     const dispatch = useDispatch();
     const navigate = useNavigate();
     const location = useLocation();
     const { width } = useWindowSize();

     const show = useSelector((state) => state.general.show);
     const user = useSelector((state) => state.subscriber.user);
     const licensee = useSelector((state) => state.subscriber.currentLicensee || JSON.parse(localStorage.getItem(LOCAL_LICENSEE)));

     const [showSetting, setShowSetting] = useState(false);

     const [showMenuMB, setShowMenuMB] = useState(false);

     const locationPath = location.pathname;

     const orgUserLocalStorage = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));
     const orgUser = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));
     const showSellingGroupFilter = removeSpecialCharacters(locationPath) === removeSpecialCharacters(GUEST_PATH.SELLING_GROUPS);

     const userRole = user?.role;
     const adminRole = isAuth() && (userRole === USER_ROLES.SYSTEM_ADMIN || userRole === USER_ROLES.SYSTEM_ADMIN_LOWER);

     const isAcceptSeatLayout = checkAcceptSeatLayout(locationPath);

     const showLicenseePopup = Boolean(
          !show && !isAuth() && !licensee && locationPath.includes('products') && !locationPath.includes('cart' || 'checkout')
     );

     const isAuthNoAdmin = isAuth() && !adminRole;
     const paramProduct = locationPath === GUEST_PATH.SELLING_GROUPS || locationPath.includes(GUEST_PATH.SELLING_GROUPS);

     const myAccountPath = adminRole ? SYSTEM_ADMIN_ROUTES : orgUserLocalStorage ? MY_ORG_PATH.ORGANIZATIONS_DASHBOARD : MY_LEARNING_PATH.DASHBOARD;

     useEffect(() => {
          if (showMenuMB) {
               document.querySelector('body').classList.add('no-scroll-body');
          } else {
               document.querySelector('body').classList.remove('no-scroll-body');
          }

          return () => {
               window.addEventListener('resize', () => {
                    if (window.innerWidth > 1140) {
                         setShowMenuMB(false);
                    }
               });
          };
     });

     const handleClickAccountIcon = () => {
          if (isAuth()) {
               navigate(myAccountPath);
          } else {
               dispatch(setShow(MODAL_LOGIN));
          }
     };

     const handClickSetting = () => {
          setShowSetting(!showSetting);
          setShowMenuMB(false);
     };

     const clickOutside = useCallback(() => {
          setShowSetting(false);
     }, []);

     useOutsideHandling(wrapperRef, clickOutside);

     return (
          <header>
               <div className="header-main">
                    <div className="container-wrapper">
                         <div className="header-main-wrapper">
                              <div className="header-left">
                                   <div className="header-logo">
                                        {(isAuthNoAdmin && paramProduct) || paramProduct ? (
                                             <a href={CAMS_CARE_URL} rel="noopener noreferrer" className="card-link">
                                                  <img src={images.logoMain} alt="CAMS Care Logo" />
                                             </a>
                                        ) : isAuthNoAdmin ? (
                                             <Link to={orgUser ? MY_ORG_PATH.ORGANIZATIONS_DASHBOARD : MY_LEARNING_PATH.DASHBOARD}>
                                                  <img src={images.logoMain} alt="CAMS Care Logo" />
                                             </Link>
                                        ) : (
                                             <Link to={SUBSCRIBER_PATH.SELLING_GROUPS}>
                                                  <img src={images.logoMain} alt="CAMS Care Logo" />
                                             </Link>
                                        )}
                                   </div>
                                   <div className="header-title">
                                        <Link to={GUEST_PATH.SELLING_GROUPS}>Training Products</Link>
                                   </div>
                              </div>

                              <div className="mb-control-wrap">
                                   <div className="mb-control">
                                        <div className="mb-control-item">
                                             {!isAcceptSeatLayout && (
                                                  <div className="buying-control">
                                                       {!adminRole && (
                                                            <div
                                                                 className="cart-link"
                                                                 onClick={() => {
                                                                      setShowMenuMB(false);
                                                                 }}
                                                            >
                                                                 <CartInfoWithPrice />
                                                            </div>
                                                       )}
                                                  </div>
                                             )}
                                        </div>
                                        {(showSellingGroupFilter || width < 676) && (
                                             <>
                                                  <div className="mb-control-item">
                                                       <div className="account-control" onClick={handleClickAccountIcon}>
                                                            <img src={images.accountIcon} alt="Account Icon" />
                                                       </div>
                                                  </div>
                                                  {adminRole && (
                                                       <div ref={wrapperRef} className="setting-icon admin d-flex">
                                                            <img src={images.settingIcon} alt="Setting Icon" onClick={handClickSetting} />
                                                            <div ref={wrapperRef} className={`setting-menu-popup${showSetting ? ' d-block' : ' '}`}>
                                                                 <ul>
                                                                      <li>
                                                                           <Link to={GUEST_PATH.MY_ACCOUNT_SETTINGS_ADMIN}>Account Settings</Link>
                                                                      </li>
                                                                 </ul>
                                                            </div>
                                                       </div>
                                                  )}
                                             </>
                                        )}
                                   </div>
                              </div>

                              <div className="header-content">
                                   <div className="header-right">
                                        {!isAcceptSeatLayout && (
                                             <div className={classNames('buying-control', { admin: adminRole })}>
                                                  {!adminRole && (
                                                       <div
                                                            className="cart-link"
                                                            onClick={() => {
                                                                 setShowMenuMB(false);
                                                            }}
                                                       >
                                                            <Link to={GUEST_PATH.CART} className="checkout-txt">
                                                                 Checkout
                                                            </Link>
                                                            <CartInfoWithPrice />
                                                       </div>
                                                  )}
                                                  {isAuth() ? (
                                                       <Link to={myAccountPath} className="signin-link">
                                                            My Account
                                                       </Link>
                                                  ) : (
                                                       <CButton
                                                            color="link"
                                                            className="btn-link signin-link"
                                                            onClick={() => {
                                                                 dispatch(setShow(MODAL_LOGIN));
                                                            }}
                                                       >
                                                            Sign In
                                                       </CButton>
                                                  )}
                                                  {adminRole && !paramProduct && (
                                                       <div ref={wrapperRef} className="setting-icon admin d-flex">
                                                            <img src={images.settingIcon} alt="Setting Icon" onClick={handClickSetting} />
                                                            <div ref={wrapperRef} className={`setting-menu-popup${showSetting ? ' d-block' : ' '}`}>
                                                                 <ul>
                                                                      <li>
                                                                           <Link to={GUEST_PATH.MY_ACCOUNT_SETTINGS_ADMIN} onClick={handClickSetting}>
                                                                                Account Settings
                                                                           </Link>
                                                                      </li>
                                                                 </ul>
                                                            </div>
                                                       </div>
                                                  )}
                                             </div>
                                        )}
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>

               {showLicenseePopup && <LicenseePopup />}
               {show === MODAL_LOGIN && <LoginModal />}
               {show === POPUP_REGISTER && <RegisterModal />}
          </header>
     );
};

const mapStateToProps = (state) => {
     return {
          general: state.general,
          subscriber: state.subscriber,
     };
};

const mapDispatchToProps = {
     toggleTheme,
     setSidebarShow,
};

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(GuestHeader));
